import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import AuthModal from "@/components/AuthModal";
import Landing from "@/pages/Landing";
import Directory from "@/pages/Directory";
import SupervisorDetail from "@/pages/SupervisorDetail";
import WriteReview from "@/pages/WriteReview";
import Analytics from "@/pages/Analytics";
import Companies from "@/pages/Companies";
import CompanyProfile from "@/pages/CompanyProfile";
import Compare from "@/pages/Compare";
import Favorites from "@/pages/Favorites";
import Admin from "@/pages/Admin";
import FAQ from "@/pages/FAQ";
import Disclaimer from "@/pages/Disclaimer";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import ResetPassword from "@/pages/ResetPassword";
import ForEmployers from "@/pages/ForEmployers";
import Vault from "@/pages/Vault";
import VaultExport from "@/components/vault/VaultExport";
import { VaultProvider } from "@/context/VaultContext";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Insights from "@/pages/Insights";
import EmployerDashboard from "@/pages/EmployerDashboard";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <VaultProvider>
          <Navbar />
          <AuthModal />
          <Toaster position="top-center" richColors />
          <main>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/supervisors" element={<Directory />} />
              <Route path="/companies" element={<Companies />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/favorites" element={<Favorites />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/company/:name" element={<CompanyProfile />} />
              <Route path="/supervisor/:id" element={<SupervisorDetail />} />
              <Route path="/supervisor/:id/review" element={<WriteReview />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/for-employers" element={<ForEmployers />} />
              <Route path="/vault" element={<Vault />} />
              <Route path="/vault/export" element={<VaultExport />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/employer" element={<EmployerDashboard />} />
            </Routes>
          </main>
          <Footer />
          </VaultProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
